export default __webpack_public_path__ + "static/apple-icon-180x180-1201fc5bce36e080efaed5bc36d120b5.png";